import { useState } from 'react';
import './addTestimony.scss';
import axios from 'axios';

const AddTestimony = (props) => {
    const [data, setData] = useState({
        customerName: "",
        verified: "",
        testimonyDate: "",
        comments: "",
        testimonyFrom: ""
    });


    const handleChange = (e) => {
        const value = e.target.value;
        setData({
            ...data,
            [e.target.name]: value
        });
    };

    const handleAddTestimony = async (e) => {
        e.preventDefault();


        const testimonyData = {
            customerName:data.customerName,
            verified:data.verified,
            testimonyDate:data.testimonyDate,
            comments:data.comments,
            testimonyFrom: data.testimonyFrom
        }

        try {
            const response =  await axios.post('http://localhost:2500/testimonials',testimonyData);
            if(response){
                console.log(response.status, response.data.token);
                props.setOpen(false);
            }
        } catch (error) {
            console.log(error.message);
        }

    }
    return (
        <div className='add'>
            <div className="modal">
                <span className="close" onClick={() => props.setOpen(false)}>X</span>
                <h1>Add new {props.slug}</h1>
                <form>
                    {props.columns.filter((item) => item.field !== "id").map(column => (
                        <div className='item' key={column.field}>
                            <label htmlFor={column.field}>{column.headerName}:</label>
                            {column.field !== "comments" &&
                                column.field !== "verified" &&
                                column.field !== "testimonyFrom" &&
                                column.field !== "testimonyDate" && <input
                                    type={column.type}
                                    name={column.field}
                                    placeholder={column.field}
                                    className={column.field}
                                    value={data.customerName}
                                    onChange={handleChange}
                                />}

                            {column.field === "verified" && <select className={column.field} name={column.field} value={data.verified} onChange={handleChange}>
                                <option value="select" >Select</option>
                                <option value="unverified" >Unverified</option>
                                <option value="verified" >Verified</option>
                            </select>}

                            {column.field === "testimonyDate" && <input 
                                                                    name={column.field} 
                                                                    type="date" 
                                                                    placeholder={column.field} 
                                                                    className={column.field} 
                                                                    value={data.testimonyDate}
                                                                    onChange={handleChange} 
                                                                />}
                            {column.field === "comments" && <textarea 
                                                                name={column.field} 
                                                                type={column.type} 
                                                                placeholder={column.field} 
                                                                className={column.field} 
                                                                value={data.comments}
                                                                onChange={handleChange} 
                                                            />}
                            {column.field === "testimonyFrom" && <select className={column.field} name={column.field} value={data.testimonyFrom} onChange={handleChange}>
                                <option value="select" >Select</option>
                                <option value="shisha" >Shisha</option>
                                <option value="google" >Google</option>
                            </select>}

                        </div>
                    ))}

                    <button onClick={handleAddTestimony}>Send</button>
                </form>
            </div >
        </div >
    )
}

export default AddTestimony